import { render, staticRenderFns } from "./DeleteRegisterInfo.vue?vue&type=template&id=0d4c7e50"
import script from "./DeleteRegisterInfo.vue?vue&type=script&lang=js"
export * from "./DeleteRegisterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports